var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.cpClass,style:(_vm.cpStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }